import React, { useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { setColor } from "../../../../../assets/styles/styles";
import { updateRoomSettingsById } from "../../../../../api/RoomsController";

const InteractionsUploadModal = ({ selected, setIsModalOpen, roomId }) => {
    const [rename, setRename] = useState("");
    const [link, setLink] = useState("");

    const addLinkJSON = async () => {
        const data = {
            linkoutPayload: {
                name: rename,
                link,
            },
        };
        await updateRoomSettingsById(roomId, data);
        setIsModalOpen(false);
    };

    return (
        <ModalContent>
            <ModalHead>Add Linkout</ModalHead>
            <ModalSub>
                Attach a link to <Yellow>{selected}</Yellow> to customize your space.
            </ModalSub>

            <FieldLabel>Add A Link</FieldLabel>
            <Input placeholder="Paste a link" maxLength={200} value={link} onChange={(e) => setLink(e.target.value)} />

            <InfoBox>
                Make sure your link is public and safe to visit. Visitors can open the link when they tap this item.
            </InfoBox>

            <FieldLabel>Rename</FieldLabel>
            <Input
                placeholder="Name this link"
                maxLength={50}
                value={rename}
                onChange={(e) => setRename(e.target.value)}
            />

            <AddButton disabled={false} onClick={addLinkJSON}>
                Add Link
            </AddButton>

            <BackButton onClick={() => setIsModalOpen(false)}>Go Back</BackButton>
        </ModalContent>
    );
};

export default InteractionsUploadModal;

const ModalContent = styled.div`
    padding: 28px;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    max-width: 700px;
`;
const ModalHead = styled.div`
    color: #ffffff;
    font-size: 22px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
`;

const ModalSub = styled.div`
    color: #d9d4e8;
    font-size: 15px;
    line-height: 22px;
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
`;

const FieldLabel = styled.div`
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    margin-top: 14px;
`;

const Input = styled.input`
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    background: #0f0c1f;
    border: 1px solid rgba(255, 255, 255, 0.09);
    color: #ffffff;
`;

const InfoBox = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 12px;
    font-size: 13px;
    color: #cfcbd8;
    line-height: 20px;
`;

const AddButton = styled.button`
    margin-top: 18px;
    padding: 12px;
    background: #7a3df0;
    border: none;
    color: white;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
        background: #8b55ff;
    }
    disable: ${(props) => (props.disabled ? "true" : "false")};
`;

const BackButton = styled.div`
    margin-top: 8px;
    text-align: center;
    color: #d3cdf1;
    cursor: pointer;
    font-size: 14px;
`;

const Yellow = styled.span`
    color: #f0c419;
    font-weight: 600;
`;

InteractionsUploadModal.propTypes = {
    selected: PropTypes.string.isRequired,
    setIsModalOpen: PropTypes.func.isRequired,
};
